import React from "react";
import { useSelector } from "react-redux";
import { Box } from "@mui/material";

import { getSelectedBadgePhotoId, selectFocusedPhotos } from "slices";
import { ProgressiveImage } from "components";

const MobilePhotoShow = () => {
  const photos = useSelector(selectFocusedPhotos);
  const selectedBadgeId = useSelector(getSelectedBadgePhotoId);

  return (
    <div className="hayley-grid hayley-h-full hayley-w-full hayley-gap-2 hayley-overflow-y-auto sm:hayley-hidden sm:hayley-gap-0 sm:hayley-bg-gray-100">
      {Object.keys(photos || {}).map((key, idx) => (
        <Box key={idx} className="hayley-flex hayley-flex-col">
          <ProgressiveImage
            classes={{
              root: "hayley-h-[320px] sm:hayley-h-[400px] md:hayley-h-[calc(100dvh-480px)] lg:hayley-h-[calc(100dvh-403px)] hayley-w-full hayley-select-none hayley-overflow-hidden hayley-bg-custom-9 hayley-text-center",
              img: "hayley-h-full hayley-w-full sm:hayley-object-contain hayley-object-center",
            }}
            src={photos[key]?.thumbnail_url}
            alt={photos[key]?.name}
            selectedId={selectedBadgeId}
            testId={`photosView_mobile_${selectedBadgeId}_image`}
          />
        </Box>
      ))}
    </div>
  );
};

export default MobilePhotoShow;
